import { lazy } from "react";

// project imports
import Loadable from "../component/Loadable/Index";
import MainLayouts from "../layout/MainLayout/index";

// login option 3 routing
const HomePage = Loadable(
  lazy(() => import("../container/HomePage/Index"))
);

const Dashboard = Loadable(
  lazy(() => import("../container/Dashboard/Index"))
)

const ContractManagement = Loadable(
  lazy(() => import('../container/ContractManagement/Index'))
)

const NewProject = Loadable(
  lazy(() => import('../container/ContractManagement/NewProject'))
)

const ContractManagementView = Loadable(
  lazy(() => import('../container/ContractManagement/ContractManagement'))
)

const ViewContract = Loadable(
  lazy(() => import('../container/ContractManagement/ViewContract/Index'))
)

const Users = Loadable(lazy(() => import("../container/User/Index")));

// Spend Analytics - existing tabbed overview
const SpendAnalytics = Loadable(lazy(() => import('../container/SpendAnalytics/Index')));

// Spend Intelligence - ported pages
const SpendUpload = Loadable(lazy(() => import('../container/SpendIntelligence/FileUploadPage')));
const SpendChat = Loadable(lazy(() => import('../container/SpendIntelligence/ChatPage')));
const SpendProcessing = Loadable(lazy(() => import('../container/SpendIntelligence/ProcessingPage')));
const SpendAnalysis = Loadable(lazy(() => import('../container/SpendAnalytics/Index')));
const SpendDataPrep = Loadable(lazy(() => import('../container/SpendIntelligence/DataPrepPage')));
const SpendCube = Loadable(lazy(() => import('../container/SpendIntelligence/SpendCubeDimensionsPage')));
const SupplierConsolidation = Loadable(lazy(() => import('../container/SpendIntelligence/SupplierConsolidationPage')));
const PriceVariances = Loadable(lazy(() => import('../container/SpendIntelligence/PriceVariancesPage')));
const TailSpend = Loadable(lazy(() => import('../container/SpendIntelligence/TailSpendPage')));
const ProcessEfficiency = Loadable(lazy(() => import('../container/SpendIntelligence/ProcessEfficiencyPage')));
const Sustainability = Loadable(lazy(() => import('../container/SpendIntelligence/SustainabilityPage')));
const OpportunityRoadmap = Loadable(lazy(() => import('../container/SpendIntelligence/OpportunityRoadmapPage')));

// ==============================|| MAIN ROUTING ||============================== //

const MainLayout = {
  path: "/",
  element: <MainLayouts />,
  children: [
    {
      path: "/home-page",
      element: <HomePage />,
    },
    {
      path:"/dashboard",
      element:<Dashboard/>
    },
    {
      path:"/contract-management",
      element:<ContractManagement/>
    },
    {
      path:"/new-project",
      element:<NewProject/>
    },
    {
      path:"/contract-management-view",
      element:<ContractManagementView/>
    },
    {
      path:"/view-contract/:guid/:path",
      element:<ViewContract />
    },
    {
      path: "/users-list",
      element: <Users />,
    },
    {
      path: "/spend-analytics",
      element: <SpendAnalytics />,
    },
    // Spend Intelligence routes
    {
      path: "/spend-analytics/upload",
      element: <SpendUpload />,
    },
    {
      path: "/spend-analytics/chat",
      element: <SpendChat />,
    },
    {
      path: "/spend-analytics/processing",
      element: <SpendProcessing />,
    },
    {
      path: "/spend-analytics/analysis",
      element: <SpendAnalysis />,
    },
    {
      path: "/spend-analytics/data-prep",
      element: <SpendDataPrep />,
    },
    {
      path: "/spend-analytics/spend-cube",
      element: <SpendCube />,
    },
    {
      path: "/spend-analytics/supplier-consolidation",
      element: <SupplierConsolidation />,
    },
    {
      path: "/spend-analytics/price-variances",
      element: <PriceVariances />,
    },
    {
      path: "/spend-analytics/tail-spend",
      element: <TailSpend />,
    },
    {
      path: "/spend-analytics/process-efficiency",
      element: <ProcessEfficiency />,
    },
    {
      path: "/spend-analytics/sustainability",
      element: <Sustainability />,
    },
    {
      path: "/spend-analytics/opportunity-roadmap",
      element: <OpportunityRoadmap />,
    },
  ],
};

export default MainLayout;
